import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'classlist-polyfill';
import 'match-media';

if (!global._babelPolyfill) {
    require('babel-polyfill');
}

switch (document.getElementById('application').getAttribute('data-renderer')) {
    case 'frontend' :
        try {
            require('./frontend');
        } catch (e) {
            console.log(e);
            console.log('Could not find frontend index.js.');
        }

        break;
    case 'backend' :
        try {
            require('./core/admin');
        } catch (e) {
            console.log('Could not find admin index.js. Are you sure the core repo is included?');
        }

        break;
    case 'loader' :
        try {
            require('./loader/');
        } catch (e) {
            console.log(e);
            console.log('Could not find Loader index.js. Are you sure the core repo is included?');
        }

        break;
    case 'widgets' :
        try {
            require('./widgets/');
        } catch (e) {
            console.log(e);
            console.log('Could not find Loader index.js. Are you sure the core repo is included?');
        }

        break;
    default :
        console.log('Invalid renderer');

        break;
}


// WEBPACK FOOTER //
// ./src/index.js